
<template>
  <div class="pdc-div">
    <div class="danghang-every" v-if="isCommonH">
      <div class="mainContainer">
        <span>当前位置：</span><span>课程详情</span>
      </div>
    </div>
    <div class="mainContainer" v-loading="loading">
      <!-- 已购买展示 -->
      <div class="pdc-top-yes" style="overflow: hidden;">
        <div id="kechengAll" :style="isFullpage?'height:100vh;':'height:560px'">
          <div class="disFlex pdc-top-yes-v">
            <div class="pdc-top-yes-v-l" :style="leftSs&&isFullpage?'width:100%;':''">
              <my-video :wjSrc="wjSrc" :havezb="productInfo.havezb" fullPageId="kechengAll" :kcdata="activeKc"
                :videoSrc="videoSrc" :isFullpage="isFullpage" @childchange="parentChange" :isks="isks"
                @changeKaoshi="changeKaoshi" @changPercent="changPercent" @saveProgress="saveProgress" />
              <div class="shensuoBtnR" v-if="isFullpage" style="right: 0;width: 30px;">
                <i v-if="leftSs" @click="leftSs=!leftSs" class="el-icon-s-fold"
                  style="font-size: 28px;cursor: pointer;color: #fff;"></i>
              </div>
            </div>
            <div class="pdc-top-yes-v-r" :style="leftSs&&isFullpage?'width:0;':''">
              <div v-for="(kecheng,k) in kclist" class="pdc-top-yes-v-r-kc" @click="bofangChange(kecheng)">
                <div class="disFlex"
                  :style="kecheng.id==activeKc.id?'align-items: center;color:#0071BA;':'align-items: center;'">
                  <div style="width: 15px;height: 15px;">
                    <img style="width: 15px;height: 15px;" v-if="!kecheng.id==activeKc.id"
                      :src="kecheng.id==activeKc.id?imgUrl2:imgUrl1" />
                    <div id="PlayCss" v-if="kecheng.id==activeKc.id">
                      <span class="soanPlay1"></span>
                      <span class="soanPlay2"></span>
                      <span class="soanPlay3"></span>
                      <span class="soanPlay4"></span>
                    </div>
                  </div>
                  <div style="padding-left: 10px;">{{k+1}} {{kecheng.cname}}</div>
                </div>
                <div class="disFlex" style="margin-top: 9px;padding-left: 27px;">
                  <div>主讲人：{{kecheng.author.length>3?kecheng.author.substring(0,3)+'...':kecheng.author}}</div>
                  <div style="margin-left: 20px;">课时：{{kecheng.ks}}课时</div>
                  <div style="margin-left: 20px;">时长：{{kecheng.xstime}}</div>
                </div>
              </div>

              <div class="shensuoBtn" v-if="isFullpage">
                <i v-if="!leftSs" @click="leftSs=!leftSs" class="el-icon-s-unfold"
                  style="font-size: 28px;cursor: pointer;color: #9a9a9a;"></i>
              </div>
            </div>
          </div>
          <div class="disFlex pdc-top-yes-jj between">
            <div class="pdc-top-yes-jj-l">
              <div class="pdc-top-yes-jj-l-tit" style="display: flex;justify-content: space-between;">
                {{productInfo.cname}}
                <div>
                  <el-button type="primary" @click="toTest" style="height: 35px;border-radius: 20px;width: 200px;">练习题
                  </el-button>
                </div>
              </div>

              <div class="pdc-top-yes-jj-l-time">有效期：{{productInfo.endtime}} | {{productInfo.buyamount}}人报名</div>
            </div>
            <div class="pdc-top-yes-jj-r">
              <el-button :type="yxnum==kclist.length?'primary':'info'" @click="startKs()"
                style="height: 50px;border-radius: 5px;width: 170px;"
                v-if="planInfo.isset==1&&planInfo.istext!=1&&yxnum==kclist.length">
                开始考试</el-button>
              <el-button @click="dialogVisiblePg=true" v-if="planInfo.ispg!='1'" type="primary"
                style="height: 50px;border-radius: 5px;width: 170px;background-color: #99CC33;border-color: #99CC33;">
                培训评价</el-button>
            </div>
          </div>
        </div>
      </div>
      <div class="disFlex between" style="margin: 20px auto;width: 1200px;">
        <div class="pdc-bot-l">
          <div class="disFlex" style="border-bottom: 1px solid #eeeeee;" v-if="isCommonH">
            <div :class="activeName=='first'?'pd-itypeName active':'pd-itypeName'" @click="changeCpshow('first')">课程介绍
            </div>
            <div :class="activeName=='second'?'pd-itypeName active':'pd-itypeName'" @click="changeCpshow('second')">课程目录
            </div>
            <div :class="activeName=='third'?'pd-itypeName active':'pd-itypeName'" @click="changeCpshow('third')">课程附件
            </div>
            <div :class="activeName=='fourth'?'pd-itypeName active':'pd-itypeName'" @click="changeCpshow('fourth')">评价
            </div>
          </div>
          <div class="tw-jj-div" v-if="activeName=='first'" style="padding: 20px;overflow-x: hidden;"
            v-html="productInfo.productinfocont?productInfo.productinfocont.conts:''">
          </div>
          <div v-if="activeName=='second'" style="padding: 10px 0;">
            <div class="pdc-bot-l-kcml" v-for="(item,i) in kclist" @click="bofangChange(item)">
              <div class="disFlex between">
                <div class="disFlex" style="align-items: center;">
                  <img style="width: 15px;height: 15px;" :src="item.id==activeKc.id?imgUrl2:imgUrl1" />
                  <span :class="item.id==activeKc.id?'activeKcTitle':'KcTitle'">课时{{i+1}}:
                    {{item.cname}}
                    <i class="el-icon-circle-check" v-if="item.isfinish=='2'" style="color: #0071BA;"></i></span>
                </div>
                <div class="disFlex" :style="item.isfinish!='0'?'color:#0071BA;':''">
                  <span v-if="item.isfinish=='2'">已学完</span>
                  <span v-if="item.id==activeKc.id&&item.isfinish=='1'">{{'已学'+parseInt(curentPercent)+'%'}}</span>
                  <span v-if="item.id!=activeKc.id&&item.isfinish=='1'">{{'已学'+parseInt(item.percent)+'%'}}</span>
                </div>
              </div>
              <div class="pdc-bot-l-kcml-jj">
                <span>主讲人：{{item.author}}</span>
                <span>课时：{{item.ks}}课时</span>
                <span>时长：{{item.xstime}}</span>
              </div>
            </div>
          </div>
          <div v-if="activeName=='third'" style="padding: 10px 0;">
            <div v-for="item in fjlist" class="disFlex"
              style="margin: 0 20px;border-bottom: 1px solid #dfdfdf;padding: 20px 0;cursor: pointer;">
              <div>
                <img v-if="item.fileType=='music'" src="@/assets/images/file_music.png" />
                <img v-else-if="item.fileType=='.xls'" src="@/assets/images/file_excel.png" />
                <img v-else-if="item.fileType=='.png'||item.fileType=='.jpg'||item.fileType=='.jepg'"
                  src="@/assets/images/file_img.png" />
                <img v-else-if="item.fileType=='.pdf'" src="@/assets/images/file_pdf.png" />
                <img v-else-if="item.fileType=='.ppt'" src="@/assets/images/file_ppt.png" />
                <img v-else-if="item.fileType=='.mp4'" src="@/assets/images/file_video.png" />
                <img v-else-if="item.fileType=='word'" src="@/assets/images/file_word.png" />
                <img v-else="item.fileType=='word'" src="@/assets/images/file_ppt.png" />
              </div>
              <div class="disFlex between"
                style="flex-direction: column;padding-left: 10px;text-align: left;font-size: 14px;">
                <div>{{item.fileName}}</div>
                <div style="color: #999999;">0人下载</div>
              </div>
            </div>
          </div>
          <div v-if="activeName=='fourth'" style="padding: 20px 0;">
            <div class="pdd-pj-my" v-if="currentUser" style="text-align: left;padding: 0px 26px 20px;">
              <div class="pdd-pj-my-tit">发表评价</div>
              <div class="disFlex between">
                <div>
                  <el-avatar size="medium" :src="currentUser.avatarurl?wjSrc+currentUser.avatarurl:txsrc"></el-avatar>
                </div>
                <div style="width: 100%;margin-left: 15px;">
                  <el-input type="textarea" :rows="2" placeholder="请输入评论内容" v-model="pjnr"></el-input>
                  <div style="text-align: right;margin-top: 15px;">
                    <el-button @click="pinglun()" type="primary" round :disabled="pjnr.length==0">发表</el-button>
                  </div>
                </div>
              </div>
            </div>
            <div v-for="item in pjList" class="disFlex between" style="padding: 20px;">
              <!-- {{+623}} -->
              <div>
                <el-avatar size="medium" :src="wjSrc+item.avatarurl"></el-avatar>
              </div>
              <div style="text-align: left;width: 100%;margin-left: 16px;">
                <div class="pl-tit">{{item.creatorName}}</div>
                <div class="pl-content">{{item.pjnr}}</div>
                <div class="disFlex between pl-bot">
                  <div>{{item.createTime}}</div>
                  <!-- 自己可以删除自己的评论 -->
                  <div style="cursor: pointer;" v-if="currentUser&&item.creator==currentUser.id"
                    @click="delPl(item.id)">删除</div>
                </div>
              </div>
            </div>

            <el-pagination :hide-on-single-page="pltotal<=10" layout="prev, pager, next" :total="pltotal"
              @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
        <div class="pdc-bot-r">
          <h3>简介</h3>
          <div :style="productInfo.isenroll=='1'?'border-bottom: 1px solid #efefef;':''">
            {{productInfo.description}}
          </div>
          <h3 v-if="productInfo.isenroll=='1'" class="disFlex between">
            <span>课程</span><span class="kc-wcd">完成度：<span
                style="color: #0071BA;">{{yxnum+'/'+kclist.length}}</span></span>
          </h3>
          <div v-if="productInfo.isenroll=='1'" class="disFlex" style="flex-wrap: wrap;">
            <div v-for="(kecheng,k) in kclist" :class="kecheng.id==activeKc.id?'pdc-bot-r-k-kc active':'pdc-bot-r-k-kc'"
              :style="k%7==6?'margin-right:0px!important;':(k%7==0?'margin-left:0px!important;':'')">
              {{k+1}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="培训评价" :visible.sync="dialogVisiblePg" width="60%">
      <my-pinggu :pgglid="planInfo.id" @changePg="changePg" ref="mypinggu" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisiblePg = false">取 消</el-button>
        <el-button type="primary" @click="savePg">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getAllKs,
    getPercent
  } from '@/assets/js/common.js';
  import MyVideo from './common/MyVideo';
  import MyPinggu from './common/MyPinggu';
  export default {
    name: 'ProductDetail',
    props: ['activeName', 'wjSrc', 'currentUser', 'isCommonH', 'isDenglu'],
    data() {
      return {
        dialogVisiblePg: false,
        leftSs: false, //右侧是否收缩
        isBuy: true,
        isks: false, //是否可以考试
        isFullpage: false,
        thisactive: '',
        pjList: [],
        curentPercent: 0,
        pjnr: '', //评价内容
        kclist: [],
        fjlist: [],
        planInfo: {},
        videoSrc: '',
        style: {
          position: 'absolute',
          width: '100%',
          height: '100%'
        },
        imgUrl1: require("@/assets/images/hasPlay.png"),
        imgUrl2: require("@/assets/images/isPlay.png"),
        imgUrl3: require("@/assets/images/notPlay.png"),
        productInfo: {
          productinfocont: {
            conts: ''
          }
        },
        activeKc: {},
        plparams: {
          page: 1,
          rows: 10
        },
        pltotal: 0,
        txsrc: require('../assets/images/notxsex.png'),
        videoProgress: '',
        yxnum: 0,
        loading: true,
        curridArr: [],
        hasSelectks: 0,
        ischange: true
      }
    },
    methods: {
      // 评论的分页点击
      handleCurrentChange: function(page) {
        this.$set(this.plparams, 'page', page);
        this.getPllist(this.activeKc.id);
      },
      changPercent: function(percent, videoCurrent) {
        this.curentPercent = percent;
        this.videoCurrent = videoCurrent;
        // 播放完毕
        if (percent >= 100) {
          // 课程查看完毕
          this.saveProgress({
            progressTimer: this.activeKc.xstime,
            videoProgress: 100
          });
        };
        this.changeKaoshi(percent);
      },
      parentChange: function(isFullpage) {
        this.isFullpage = isFullpage;
      },
      changeCpshow: function(flag) {
        this.$emit('changeCpitype', flag);
      },
      // 视频组件传来  可以开始考试了
      changeKaoshi: function(percent) {
        var id = this.activeKc.id;
        var flag = true;
        this.kclist.map((item, i) => {
          if (item.id == id && !this.ischange) {
            item.percent = percent;
            this.$set(this.kclist[i], 'percent', percent);
            this.ischange = false;
          }
          if (parseFloat(item.percent) < 90 && item.isfinish != '2') {
            flag = false
          }
        })
        this.isks = flag;
      },
      // 开始考试
      startKs: function() {
        if (this.isks) {
          this.$set(this.planInfo, 'istext', 1);
          sessionStorage.setItem('planId', this.planInfo.id),
            sessionStorage.setItem('productKsitype', this.planInfo.ontype);
          const {
            href
          } = this.$router.resolve({
            name: 'PlanKs',
            query: {}
          });
          window.open(href, '_blank');
        } else {
          this.$message.warning('学习时长较短，请继续学习！')
        }
      },
      getKcdetail: function() {
        if (!ispercent) {
          this.loading = true;
        };
        this.$axios.get('/kt/wz/productInfo/getProdcutallDetail.htm?id=' + id, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.productInfo = data.data;

            this.activeKc = this.kclist[0];
            this.curentPercent = this.activeKc.percent;
            this.videoSrc = this.kclist[0].filepath;
          };
        })

      },
      // 获取产品详情
      getData: function(id, ispercent) {
        if (!ispercent) {
          this.loading = true;
        };
        this.$axios.get('/kt/ktProductLeanplan/getMyxxrwDetail.htm?id=' + id, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.planInfo = data.data;
            var yxnum = 0;
            if (!ispercent) {
              data.data.listkcs.map((item) => {
                if (item.isfinish == '1' && !item.percent) {
                  item.percent = getPercent(item.finishtime, item.xstime);
                }
                if (item.isfinish == '2') {
                  yxnum++;
                }
                this.$set(item, 'allks', getAllKs(item.xstime))
              });
              this.productInfo = data.data.listkcs[0];
              this.yxnum = yxnum; //已完成的课程数量
              this.kclist = data.data.listkcs;
              this.activeKc = this.kclist[0];
              this.curentPercent = this.activeKc.percent;
              this.videoSrc = this.kclist[0].filepath;

              // 获取评论列表
              this.getPllist(this.activeKc.id);
              // 获取附件列表
              this.getFjlist(this.activeKc.id);

            };
            if (data.data.isset == '1') {
              var isks = true;
              data.data.listkcs.map((item) => {
                if (item.isfinish == '1') {
                  isks = false;
                }
              });
              this.isks = isks;
            };
            this.loading = false;
          } else {
            this.$message.error(data.message);
            this.loading = true;
          }
        })
      },
      // 获取评论列表
      getPllist: function(id) {
        this.$set(this.plparams, 'productid', id);
        this.$axios.get('/kt/ktProductEvaluate/getlistPage.htm?' + this.$qs.stringify(this.plparams), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          this.pjList = data.rows;
          this.pltotal = data.total;
        })
      },
      // 获取附件列表
      getFjlist: function(kcid) {
        this.$axios.get('/kt/wz/productInfo/getFjByProductId.htm?currId=' + kcid, {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          this.fjlist = data.data;
        })
      },
      // 添加评论
      pinglun: function() {
        var params = {
          productname: this.productInfo.cname,
          productid: this.productInfo.id,
          pjnr: this.pjnr,
          cid: this.currentUser.cid,
          creatorName: this.currentUser.realName
        };
        this.$axios.post('/kt/ktProductEvaluate/add.htm', this.$qs.stringify(params), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.pjnr = '';
            this.$message.success(data.message);
            this.getPllist(this.productInfo.id);
          } else {
            this.$message.error(data.message);
          }
        })
      },
      // 课程播放修改
      bofangChange: function(kecheng) {
        if (kecheng.id == this.activeKc.id) {

        } else {
          var kclist = this.kclist;
          // 课程播放切换  切换之前的课程查看进去前端暂时保存
          kclist.map((item, i) => {
            if (item.id == this.activeKc.id) {
              item.percent = this.curentPercent;
              item.finishtime = this.videoCurrent;
              this.$set(this.kclist, i, item);
            }
          });
          this.activeKc = kecheng;
          this.videoSrc = kecheng.filepath;
          this.ischange = true;
          this.curentPercent = kecheng.percent;
          this.productInfo = kecheng;


          // 获取评论列表
          this.getPllist(kecheng.id);
          // 获取附件列表
          this.getFjlist(kecheng.id);

        }
      },
      changePg(pgparams) {
        console.log(pgparams)
      },
      savePg() {
        const loading = this.$loading({
          lock: true,
          text: '评价结果提交中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        var pglist = this.$refs.mypinggu._data.pglist;
        var jsons = [];
        var dataId = this.planInfo.id;
        pglist.map((item) => {
          item.list && item.list.map((child) => {
            jsons.push({
              dataId: dataId,
              itemCode: child.id,
              itemName: child.name,
              itemVal: child.itemVal
            })
          })
        });
        this.$axios.post('/kt/ktAppraiseUser/addBatch.htm', this.$qs.stringify({
          json: JSON.stringify(jsons)
        })).then(res => {
          var data = res.data;
          this.loading = false;
          if (data.stat == '1') {
            loading.close();
            this.dialogVisiblePg = false;
            this.planInfo.ispg=1;
          } else {
            this.$message.error(data.message);
          }
        })
      },
      // 保存课程的播放进度
      saveProgress: function(obj) {
        var params = {
          productname: this.planInfo.planname,
          productid: this.planInfo.id,
          itype: this.planInfo.ontype,
          cname: this.activeKc.cname,
          dataid: this.activeKc.id,
          studyTime: obj.progressTimer,
          allTime: this.activeKc.xstime,
          percent: obj.videoProgress ? obj.videoProgress : 0
        };
        this.$axios.post('/kt/ktStudyRecord/add.htm', this.$qs.stringify(params), {
          headers: {
            "X-Requested-With": "XMLHttpRequest",
          }
        }).then(res => {
          var data = res.data;
          if (data.stat == '1') {
            this.getData(this.$route.query.id, 1);
          } else {}
        });
      },
      delPl: function(id) {
        var $this = this;
        this.$confirm('您确定要删除该评论吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.get('/kt/ktProductEvaluate/del.htm?id=' + id).then(res => {
            var data = res.data;
            if (data.stat == '1') {
              this.$message({
                message: data.message,
                type: 'success'
              });
              this.getPllist(this.activeKc.id);
            } else {
              this.$message.error(data.message);
            }
          })
        }).catch(() => {});
      },
      // 跳转练习题页面 去练习
      toTest: function() {
        this.$router.push('/testQuestion?id=' + this.activeKc.id);
      },
    },
    components: {
      MyVideo,
      MyPinggu
    },
    created: function() {
      this.thisactive = this.activeName;
      // 获取计划详情
      this.getData(this.$route.query.id);
    },
    watch: {
      activeName: function(old, newval) {
        this.thisactive = newval
      },
      isks: function(old, newval) {
        console.log('isks:', old, newval);
      },
    },
    mounted: function() {},
    beforeDestroy: function() {
      if (this.currentUser && this.productInfo.isenroll && this.productInfo.isxk == '1') {
        this.saveProgress({
          progressTimer: this.videoCurrent,
          videoProgress: this.curentPercent
        })
      };
    }
  }
</script>

<style>
  .pdc-div {}

  /* 已购买的上面的样式 */
  .pdc-top-not {
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    padding: 20px;
    display: flex;

  }

  .pdc-top-not-l {
    width: 345px;
    height: 207px;
    opacity: 1;
    background: #e6e6e6;
    border-radius: 4px;
    margin-right: 24px;
  }

  .pdc-top-not-l img {
    width: 345px;
    height: 207px;
    border-radius: 4px;
    margin-right: 24px;
  }

  .pdc-top-not-r-tit {
    font-size: 24px;
    font-family: "PingFang SC";
    font-weight: 500;
    text-align: left;
    color: #333333;
    line-height: 33px;
  }

  .pdc-top-not-r-jiage {
    font-size: 13px;
    font-family: "PingFang SC";
    font-weight: 400;
    text-align: left;
    color: #9a9a9a;
    line-height: 18px;
    margin: 27px 0 25px 0;
  }

  .pdc-top-not-r-price {
    width: 770px;
    height: 50px;
    opacity: 1;
    background: #f7f8fb;
    text-align: left;
    font-size: 30px;
    font-family: DINAlternate, DINAlternate-Bold;
    font-weight: 700;
    text-align: justify;
    color: #d50000;
    line-height: 50px;
    letter-spacing: 2px;
    padding-left: 20px;
    margin-bottom: 13px;
  }

  /* 为购买的上面的样式 */
  .pdc-top-yes {
    opacity: 1;
    background: #ffffff;
    border-radius: 12px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.03);
    padding: 20px;
  }

  .pdc-top-yes-v {
    height: calc(100% - 106px);
  }

  .pdc-top-yes-v-l {
    width: calc(100% - 400px);
    opacity: 0.6;
    background: #000000;
    position: relative;
  }

  .pdc-top-yes-v-r {
    width: 400px;
    opacity: 1;
    background: #000000;
    height: 100%;
    overflow: auto;
    position: relative;
  }

  .pdc-top-yes-v-r::-webkit-scrollbar {
    width: 4px;
    height: 20px;
    opacity: 1;
    background: #232323;
    border-radius: 2px;
  }

  .pdc-top-yes-v-r::-webkit-scrollbar-thumb {
    background: #6a6969;
    border-radius: 2px;
  }

  .pdc-top-yes-v-r-kc {
    color: #9a9a9a;
    padding: 22px 0 18px 0px;
    margin: 0 18px;
    border-bottom: 1px solid #525252;
    font-size: 14px;
    cursor: pointer;
  }

  .pdc-top-yes-jj {
    opacity: 1;
    background: #333333;
    color: #fff;
    padding: 12px 40px 14px 28px;
    text-align: left;
  }

  .pdc-top-yes-jj-l {
    width: calc(100% - 400px - 68px);
    font-size: 20px;
    letter-spacing: 1px;
  }

  .pdc-top-yes-jj-l-time {
    margin-top: 8px;
    color: #dfdfdf;
    letter-spacing: 1px;
    font-size: 14px;
  }

  .pdc-top-yes-jj-r {
    padding-top: 15px;
  }

  .pdc-bot-l {
    background-color: #fff;
    width: 856px;
    border-radius: 4px;
    box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.03);
    padding: 0 0 20px 0;
  }

  .pd-itypeName {
    padding: 20px;
    width: 100px;
    font-size: 16px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: #333333;
    letter-spacing: 1px;
    cursor: pointer;
  }

  .pd-itypeName.active {
    color: #0071BA;
    border-bottom: 2px solid #0071BA;
  }

  .pdc-bot-r {
    width: 326px;
    opacity: 1;
    background: #ffffff;
    border-radius: 4px;
    text-align: left;
  }

  .pdc-bot-r h3 {
    margin: 15px 20px 0px 19px;
    font-size: 16px;
    color: #333333;
  }

  .pdc-bot-r h3 .kc-wcd {
    font-size: 12px;
    color: #9a9a9a;
  }

  .pdc-bot-r div {
    margin: 15px 18px 20px 18px;
    padding-bottom: 20px;
    color: #9a9a9a;
    font-size: 14px;
  }

  .pdc-bot-r-k-kc {
    width: 36px;
    height: 36px;
    opacity: 1;
    background: #efefef;
    border-radius: 1px;
    margin: 0px 6px 6px 0 !important;
    padding: 0 !important;
    text-align: center;
    line-height: 36px;
    cursor: pointer;
  }

  .pdc-bot-r-k-kc.active {
    background: #def2ff;
    color: #0071BA;
  }

  .pdc-bot-l-kcml {
    padding: 20px 0 15px;
    margin: 0 20px;
    text-align: left;
    color: #9a9a9a;
    font-size: 14px;
    border-bottom: 1px solid #d8d8d8;
    cursor: pointer;
  }

  .pdc-bot-l-kcml .KcTitle {
    padding-left: 10px;
    font-weight: 500;
    font-size: 18px;
    color: #9a9a9a;
    letter-spacing: 1px;
    font-family: "PingFang SC";
  }

  .pdc-bot-l-kcml .activeKcTitle {
    padding-left: 10px;
    font-weight: 500;
    font-size: 18px;
    letter-spacing: 1px;
    font-weight: 500;
    font-family: "PingFang SC";
    color: #0071BA;
  }

  .pdc-bot-l-kcml-jj {
    font-size: 14px;
    font-family: "PingFang SC";
    text-align: left;
    color: #9a9a9a;
    letter-spacing: 1px;
    padding: 10px 0 10px 25px;
  }

  .pdc-bot-l-kcml-jj span {
    padding-right: 20px;
  }

  .pdd-pj-my {
    border-bottom: 1px solid #eeeeee;
  }

  .pdd-pj-my-tit {
    font-size: 16px;
    font-family: 'PingFangSC';
    font-weight: 500;
    color: #333333;
    line-height: 22px;
    letter-spacing: 1px;
    margin-bottom: 20px;
  }

  /* 评论的样式 */
  .pl-tit {
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: left;
    color: #333333;
    line-height: 20px;
    letter-spacing: 1px;
  }

  .pl-content {
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    color: #333333;
    line-height: 20px;
    letter-spacing: 1px;
    margin-top: 9px;
  }

  .pl-bot {
    margin-top: 9px;
    opacity: 1;
    font-size: 14px;
    font-family: 'PingFangSC';
    font-weight: 400;
    text-align: left;
    color: #9a9a9a;
    line-height: 20px;
    letter-spacing: 1px;
  }

  .tw-jj-div {
    font-size: 14px;
    line-height: 25px;
    text-align: left;
  }

  .tw-jj-div img {
    max-width: 100%;
  }

  .shensuoBtn {
    position: absolute;
    left: 0;
    top: 50%;
  }

  .shensuoBtnR {
    position: absolute;
    right: 0;
    top: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/PlanDetail.vue